import { AML_STATUS_QUERY, GRACE_PERIOD_QUERY, ACCOUNT_IS_PROCESSING_STATUS_QUERY, COREX_AML_STATUS_QUERY, COREX_GRACE_PERIOD_QUERY, AML_ID_AND_ADDRESS_VERIFIED, USER_PENDING_QUESTIONNAIRES_QUERY, COREX_AML_FILES_QUERY, USER_LOGGED_IN_UPDATED, UPDATE_AML_STATUS, AML_STATUS_UPDATED, GRACE_PERIOD_UPDATED, USER_PROFILE_DATA, UPDATE_DEPOSIT_RESTRICTION, ACCOUNT_IS_VERIFIEDPARTIAL_NOTIFICATION, ACCOUNT_IS_VERIFIED_NOTIFICATION } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { getComplianceStatus } from '../../utils/kyc-corex.js';
import { mapToAmlStatusResponse } from '../keycloak/keycloak.profile.js';
import { transformUserComplianceToLowercase } from '../../utils/helpers.js';
import { QuestionnaireStatus } from '@gig/magic-sdk/dist/adapter/users/getUserQuestionnaires';

// 8 minute interval in line with current SOW application.
var CHECK_INTERVAL_MINUTES = 8 * 60 * 1000;
var AmlCorexService = /** @class */ (function () {
    function AmlCorexService() {
        var _this = this;
        this.isLoggedIn = false;
        this.loading = false;
        this.isProcessing = false;
        this.isApproved = false;
        this.profileData = null;
        this.uploadedFiles = null;
        this.amlTimerInterval = CHECK_INTERVAL_MINUTES;
        this.intervalID = null;
        this.magicSubscriptions = [];
        this.querySubscriptions = [];
        this.amlHandler = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.unsubscribeQueries();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        return [4 /*yield*/, this.updateAmlStatus()];
                    case 2:
                        _a.sent();
                        this.setIsProcessing();
                        this.setIsApproved();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.log('unable to update aml status', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.registerQueryHandlers();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.registerEvents();
        this.subscribeToUserLoginChanges();
        this.subscribeUpdateAmlCommand();
    }
    AmlCorexService.prototype.registerQueryHandlers = function () {
        var _this = this;
        this.querySubscriptions.push(window.queryBus.subscribe(AML_STATUS_QUERY, function () {
            var amlStatus = _this.getAmlStatus();
            if (amlStatus) {
                return mapToAmlStatusResponse(amlStatus);
            }
            return null;
        }));
        // adding it to avoid grace period queries being rejected
        this.querySubscriptions.push(window.queryBus.subscribe(GRACE_PERIOD_QUERY, function () {
            return [];
        }));
        this.querySubscriptions.push(window.queryBus.subscribe(ACCOUNT_IS_PROCESSING_STATUS_QUERY, function () {
            return _this.isLoggedIn && _this.isProcessing;
        }));
        this.querySubscriptions.push(window.queryBus.subscribe(COREX_AML_STATUS_QUERY, function () {
            return _this.getAmlStatus();
        }));
        this.querySubscriptions.push(window.queryBus.subscribe(COREX_GRACE_PERIOD_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            var promise, userRestrictions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = magic.invokeCached(60, magic.methods.responsibleGaming, 'getUserRestrictions')({
                            userProfileId: magic.session.getUser().id,
                        });
                        return [4 /*yield*/, promise];
                    case 1:
                        userRestrictions = _a.sent();
                        return [2 /*return*/, userRestrictions.find(function (restriction) {
                                return restriction.externalId === 'aml-verification-policy' &&
                                    restriction.status !== 'Deleted';
                            })];
                }
            });
        }); }));
        this.querySubscriptions.push(window.queryBus.subscribe(AML_ID_AND_ADDRESS_VERIFIED, function () {
            return _this.isLoggedIn && _this.isApproved;
        }));
        this.querySubscriptions.push(window.queryBus.subscribe(USER_PENDING_QUESTIONNAIRES_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            var questionnaires;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, magic.methods.users.getUserQuestionnaires({
                            userProfileId: magic.session.getUser().id,
                        })];
                    case 1:
                        questionnaires = _a.sent();
                        return [2 /*return*/, questionnaires.some(function (q) { return q.status === QuestionnaireStatus.REQUESTED; })];
                }
            });
        }); }));
        this.querySubscriptions.push(window.queryBus.subscribe(COREX_AML_FILES_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.isLoggedIn) {
                    return [2 /*return*/, []];
                }
                if (this.uploadedFiles) {
                    return [2 /*return*/, this.uploadedFiles];
                }
                return [2 /*return*/, this.fetchUploadedFiles()];
            });
        }); }));
    };
    AmlCorexService.prototype.fetchUploadedFiles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, magic.invokeCached(60, magic.methods.users, 'getUserDocuments')()];
                    case 1:
                        _a.uploadedFiles = _c.sent();
                        return [2 /*return*/, this.uploadedFiles || []];
                    case 2:
                        _b = _c.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmlCorexService.prototype.unsubscribeQueries = function () {
        this.querySubscriptions.forEach(function (subscription) {
            return subscription.unsubscribe();
        });
        this.querySubscriptions = [];
    };
    AmlCorexService.prototype.subscribeToUserLoginChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoggedIn = !!e.payload;
                        return [4 /*yield*/, this.amlHandler()];
                    case 1:
                        _a.sent();
                        if (this.isLoggedIn && !this.intervalID) {
                            this.setAmlGetterInterval();
                            this.subscribeToMagicEvents();
                        }
                        else {
                            this.clearAmlInterval();
                            this.clearMagicSubscriptions();
                        }
                        this.resetFilesCache();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    AmlCorexService.prototype.subscribeUpdateAmlCommand = function () {
        var _this = this;
        window.commandBus.subscribe(UPDATE_AML_STATUS, function () {
            return _this.amlHandler();
        });
    };
    AmlCorexService.prototype.setIsProcessing = function () {
        // If we know the KYC status we can display some notifications to the user to
        // explain what their status is.
        this.isProcessing = false;
        var amlStatus = this.getAmlStatus();
        if (!amlStatus) {
            return;
        }
        var processing = 'Pending';
        var disallowed = ['Failed'];
        if (disallowed.includes(amlStatus.idVerificationStatus) ||
            disallowed.includes(amlStatus.addressVerificationStatus)) {
            this.isProcessing =
                amlStatus.idVerificationStatus === processing ||
                    amlStatus.addressVerificationStatus === processing;
        }
    };
    AmlCorexService.prototype.setIsApproved = function () {
        this.isApproved = false;
        var amlStatus = this.getAmlStatus();
        if (!amlStatus) {
            return;
        }
        var approvedStatuses = [
            'Verified',
            'VerifiedPartial',
        ];
        this.isApproved =
            approvedStatuses.includes(amlStatus.idVerificationStatus) &&
                approvedStatuses.includes(amlStatus.addressVerificationStatus);
    };
    AmlCorexService.prototype.registerEvents = function () {
        window.queryBus.register(AML_STATUS_QUERY, {
            type: 'object',
        });
        window.queryBus.register(GRACE_PERIOD_QUERY, {
            type: 'array',
        });
        window.eventBus.register(AML_STATUS_UPDATED, {
            type: ['object', 'null'],
        });
        window.eventBus.register(GRACE_PERIOD_UPDATED, {
            type: 'array',
        });
        window.queryBus.register(COREX_AML_STATUS_QUERY, {
            type: 'object',
        });
        window.queryBus.register(COREX_GRACE_PERIOD_QUERY, {
            type: 'object',
        });
    };
    AmlCorexService.prototype.updateAmlStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isLoggedIn) {
                            this.profileData = null;
                            this.publishAmlChange();
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, magic.invokeCached(5, magic.methods.users, 'getUserProfile')()];
                    case 2:
                        _a.profileData = (_b.sent());
                        this.publishAmlChange();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        console.error('aml status fetch failed', e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AmlCorexService.prototype.getAmlStatus = function () {
        if (!this.profileData) {
            return null;
        }
        return this.profileData.compliance;
    };
    AmlCorexService.prototype.subscribeToMagicEvents = function () {
        var _this = this;
        this.magicSubscriptions.push(magic.events.userProfileUpdated(function (eventData) { return __awaiter(_this, void 0, void 0, function () {
            var compliance, isDepositAllowedUpdated, query;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        compliance = (_a = eventData === null || eventData === void 0 ? void 0 : eventData.Current) === null || _a === void 0 ? void 0 : _a.Compliance;
                        if (!((_b = eventData === null || eventData === void 0 ? void 0 : eventData.Current) === null || _b === void 0 ? void 0 : _b.Compliance.IsDepositAllowed)) return [3 /*break*/, 2];
                        isDepositAllowedUpdated = (_c = eventData === null || eventData === void 0 ? void 0 : eventData.Current) === null || _c === void 0 ? void 0 : _c.Compliance.IsDepositAllowed;
                        return [4 /*yield*/, window.eventBus.publish(UPDATE_DEPOSIT_RESTRICTION, isDepositAllowedUpdated)];
                    case 1:
                        _f.sent();
                        _f.label = 2;
                    case 2:
                        if (!(((_e = (_d = eventData === null || eventData === void 0 ? void 0 : eventData.Current) === null || _d === void 0 ? void 0 : _d.Compliance) === null || _e === void 0 ? void 0 : _e.IsPromotionsAllowed) !==
                            undefined)) return [3 /*break*/, 4];
                        return [4 /*yield*/, window.eventBus.publish(USER_PROFILE_DATA, eventData.Current.Compliance.IsPromotionsAllowed)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        if (!this.profileData || !compliance) {
                            return [2 /*return*/, this.amlHandler()];
                        }
                        query = this.shouldUpdateKycStatus(this.profileData, compliance);
                        if (query) {
                            window.eventBus.publish(query);
                        }
                        this.profileData.compliance =
                            transformUserComplianceToLowercase(compliance);
                        this.publishAmlChange();
                        return [2 /*return*/];
                }
            });
        }); }).unsub);
        this.magicSubscriptions.push(magic.events.verificationDocumentsUpdated(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetFilesCache();
                        return [4 /*yield*/, Promise.all([
                                this.fetchUploadedFiles(),
                                this.amlHandler(),
                            ])];
                    case 1:
                        _a.sent();
                        this.publishAmlChange();
                        return [2 /*return*/];
                }
            });
        }); }).unsub);
    };
    AmlCorexService.prototype.publishAmlChange = function () {
        var amlStatus = this.getAmlStatus();
        window.eventBus.publish(AML_STATUS_UPDATED, amlStatus && mapToAmlStatusResponse(amlStatus));
    };
    AmlCorexService.prototype.resetFilesCache = function () {
        this.uploadedFiles = null;
        magic.deleteCached(magic.methods.users, 'getUserDocuments')();
    };
    AmlCorexService.prototype.clearMagicSubscriptions = function () {
        this.magicSubscriptions.forEach(function (unsub) { return unsub(); });
        this.magicSubscriptions = [];
    };
    AmlCorexService.prototype.setAmlGetterInterval = function () {
        var _this = this;
        this.clearAmlInterval();
        this.intervalID = setInterval(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.amlHandler()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); }, this.amlTimerInterval);
    };
    AmlCorexService.prototype.clearAmlInterval = function () {
        if (!!this.intervalID) {
            clearInterval(this.intervalID);
        }
        this.intervalID = null;
    };
    AmlCorexService.prototype.shouldUpdateKycStatus = function (profileData, compliance) {
        var currentStatus = getComplianceStatus(profileData.compliance);
        var newStatus = getComplianceStatus(transformUserComplianceToLowercase(compliance));
        if ((currentStatus === 'Failed' || currentStatus === 'Pending') &&
            newStatus === 'VerifiedPartial') {
            return ACCOUNT_IS_VERIFIEDPARTIAL_NOTIFICATION;
        }
        if ((currentStatus === 'Failed' ||
            currentStatus === 'Pending' ||
            currentStatus === 'VerifiedPartial') &&
            newStatus === 'Verified') {
            return ACCOUNT_IS_VERIFIED_NOTIFICATION;
        }
        return null;
    };
    return AmlCorexService;
}());

export { AmlCorexService };
